export const PhoneFrame = ({ children, className = "" }) => (
  <div className={`phone-frame-shadow relative w-[290px] shrink-0 overflow-hidden rounded-[2.6rem] border-[10px] border-slate-900 bg-slate-900 ${className}`}>
    <div className="absolute left-1/2 top-2 z-20 h-5 w-24 -translate-x-1/2 rounded-full bg-slate-900" />
    <div className="relative h-[580px] w-full overflow-hidden rounded-[2rem] bg-[#F8FAFC]">
      {children}
    </div>
  </div>
);

export const StatusBar = () => (
  <div className="flex items-center justify-between px-5 pb-1 pt-4 text-[10px] font-semibold text-slate-700">
    <span>9:41</span>
    <span className="flex items-center gap-1">
      <span className="inline-block h-2 w-3 rounded-[2px] bg-slate-400" />
      <span className="inline-block h-2 w-2 rounded-full bg-slate-400" />
      <span className="inline-block h-2 w-4 rounded-[3px] bg-slate-700" />
    </span>
  </div>
);

export const AppHeader = ({ title, subtitle }) => (
  <div className="px-5 pb-3 pt-2">
    <div className="flex items-center justify-between">
      <div>
        <p className="font-heading text-lg font-extrabold text-slate-900">{title}</p>
        {subtitle && <p className="text-[11px] text-slate-500">{subtitle}</p>}
      </div>
      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#1B4D3E] text-[11px] font-bold text-lime-300">JD</div>
    </div>
  </div>
);

export const CheckItem = ({ done, label, meta, accent }) => (
  <div className="mx-4 mb-2 flex items-center gap-3 rounded-2xl border border-slate-100 bg-white px-3.5 py-3 shadow-sm">
    <span
      className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${done ? "border-emerald-600 bg-emerald-600" : "border-slate-300"}`}
    >
      {done && (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M2 5.2 4.2 7.4 8 3" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </span>
    <div className="min-w-0 flex-1">
      <p className={`truncate text-[13px] font-medium ${done ? "text-slate-400 line-through" : "text-slate-800"}`}>{label}</p>
      {meta && <p className="text-[10px] text-slate-400">{meta}</p>}
    </div>
    {accent && <span className="rounded-full bg-lime-100 px-2 py-0.5 text-[9px] font-bold text-emerald-800">{accent}</span>}
  </div>
);

export const VoiceWave = ({ bars = 24, className = "" }) => (
  <div className={`flex h-10 items-center justify-center gap-[3px] ${className}`}>
    {Array.from({ length: bars }).map((_, i) => (
      <span
        key={i}
        className="wave-bar w-[3px] rounded-full bg-emerald-500"
        style={{ height: `${18 + Math.abs(Math.sin(i * 1.4)) * 22}px`, animationDelay: `${i * 0.07}s` }}
      />
    ))}
  </div>
);

export const BottomNav = () => (
  <div className="absolute inset-x-0 bottom-0 flex items-center justify-around border-t border-slate-100 bg-white px-4 py-3">
    {["Today", "Tasks", "Voice", "Calendar", "More"].map((t, i) => (
      <span key={t} className={`text-[10px] font-semibold ${i === 2 ? "flex h-9 w-9 -translate-y-3 items-center justify-center rounded-full bg-[#1B4D3E] text-lime-300 shadow-lg" : "text-slate-400"}`}>
        {i === 2 ? (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
            <rect x="9" y="2" width="6" height="12" rx="3" />
            <path d="M5 10a7 7 0 0 0 14 0M12 19v3" />
          </svg>
        ) : t}
      </span>
    ))}
  </div>
);
